var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"sm":"4"}},[_c('iGateReport')],1),_c('CCol',{attrs:{"sm":"5"}},[_c('PortalReport')],1),_c('CCol',{attrs:{"sm":"3"}},[_c('MeetingStatistics')],1)],1),_c('RpStatistical'),_c('DocumentReport')],1)}
var staticRenderFns = []

export { render, staticRenderFns }